var exports = {
  "SW": "TableGamesEntry.module__popout___WG9OS0",
  "Ev": "TableGamesEntry.module__sheetBody___WG9OS0",
  "jw": "TableGamesEntry.module__chip___WG9OS0",
  "Go": "TableGamesEntry.module__chipName___WG9OS0",
  "F4": "TableGamesEntry.module__chipGame___WG9OS0",
};

module.exports = exports;
